import { Tv, Clapperboard, Sparkles, MonitorSmartphone, Gauge, Wrench } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

export const SERVICES = [
  { icon: Tv, title: "Live TV", desc: "Watch live channels in crisp quality with a smooth, reliable viewing experience." },
  { icon: Clapperboard, title: "Movies & Shows", desc: "A world of movies and series ready whenever you want to press play." },
  { icon: Sparkles, title: "Premium Entertainment", desc: "A curated entertainment experience designed for people who expect more." },
  { icon: MonitorSmartphone, title: "Multi-Device Streaming", desc: "One hub across your TV, phone, tablet and favourite streaming devices." },
  { icon: Gauge, title: "HD Streaming", desc: "Sharp HD and Full HD picture quality, optimised for fast, stable playback." },
  { icon: Wrench, title: "Easy Setup", desc: "Simple step-by-step instructions that get you streaming in minutes." },
];

export default function Services() {
  return (
    <section id="services" className="section-fade relative overflow-hidden py-16 md:py-28" data-testid="services-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          overline="What we offer"
          title="Entertainment built around you"
          sub="Everything you need for a complete streaming experience — fast, beautiful and effortless."
        />
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.title} delay={i * 0.07}>
              <div
                data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="glass glass-hover group h-full rounded-2xl p-7"
              >
                <div className="mb-5 inline-flex h-12 w-12 items-center justify-center rounded-xl border border-electric/25 bg-electric/10 text-electric shadow-[0_0_18px_rgba(0,240,255,0.18)] transition-transform duration-300 group-hover:scale-110">
                  <s.icon className="h-5 w-5" />
                </div>
                <h3 className="font-display text-lg font-semibold text-slate-900">{s.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-500">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
